import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { getFxDisabledRoles, getFxEnabledRoles } from 'common/utils/user';

export const DCR_DASHBOARD_PERMISSIONS = [];

export const DCR_DASHBOARD_ROLES = [
    RoleVariantEnum.SiteInvestigator,
    RoleVariantEnum.SiteCoordinator,
    RoleVariantEnum.Inspector,
    RoleVariantEnum.DataChangeSupport,
    RoleVariantEnum.Monitor,
    ...getFxDisabledRoles(),
];

export const DCR_MANAGEMENT_ROLES: (BaseRoles | RoleVariantEnum)[] = [
    BaseRoles.AdminId,
    RoleVariantEnum.StudyBuilder,
    RoleVariantEnum.StudySupport,
    RoleVariantEnum.AdminReadOnly,
    ...getFxEnabledRoles(),
];
